import { atom } from 'jotai';

export const collapseMobileAtom = atom(true);
export const collapseDesktopAtom = atom(false);
export const openAtom = atom(true);

// Sidebar collapsed state - shared between sidebar and editor
export const sidebarCollapsedAtom = atom(false);
